import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';
import { checkIsAppLoadedInIframe } from 'utils/iframe';

export const DOCUMENTS_ROUTING_PARAMS = {
  legacyLoanNumber: 'legacyLoanNumber',
  docId: 'docId',
};

const isHubspotSession = checkIsAppLoadedInIframe();

const documentsHubspotLayoutConfig = {
  toolbar: { display: false },
};

export class DocumentsPaths {
  static documents = new EnhancedPath('/documents');

  static documentsByLoanNumber = new EnhancedPath(
    `${DocumentsPaths.documents.path}/portal-number/:${DOCUMENTS_ROUTING_PARAMS.legacyLoanNumber}`,
  );

  static documentPreview = new EnhancedPath(
    `${DocumentsPaths.documents.path}/preview/:${DOCUMENTS_ROUTING_PARAMS.docId}`,
  );
}

const routesConfig = {
  settings: {
    layout: { config: isHubspotSession ? documentsHubspotLayoutConfig : {} },
  },
  routes: [
    {
      path: DocumentsPaths.documents.path,
      component: lazyWithRetry(() => import('app/pages/documents/documents')),
      pageCode: PAGE_CODES.LOAN_DOCUMENT,
      exact: true,
    },
    {
      path: DocumentsPaths.documentsByLoanNumber.path,
      component: lazyWithRetry(() => import('app/pages/documents/legacyDocuments')),
      pageCode: PAGE_CODES.DOCUMENTS,
      exact: true,
    },
    {
      path: DocumentsPaths.documentPreview.path,
      component: lazyWithRetry(() => import('app/pages/documents/documents/DocumentPreview')),
      pageCode: PAGE_CODES.LOAN_APPLICATION,
    },
  ],
};

export default routesConfig;
